import { SegmentedToggle } from '@hakimo-ui/shared/ui-base';
import { SUB_CATEGORY_OPTIONS, type SubCategory } from '../util';

interface CategoryToggleProps {
  value: SubCategory;
  onChange: (value: SubCategory) => void;
}

export function CategoryToggle({ value, onChange }: CategoryToggleProps) {
  return (
    <div className="pl-6">
      <SegmentedToggle
        value={value}
        options={SUB_CATEGORY_OPTIONS.map((o) => ({
          id: o.value,
          label: o.label,
        }))}
        variant="pill"
        onChange={(v) => onChange(v as SubCategory)}
        className="flex-wrap gap-1"
      />
    </div>
  );
}
